import React from 'react';
import CasinoDirectoryTable from '../components/CasinoDirectoryTable';

const DirectoryPage = () => {
  return (
    <div className="p-6" style={{ backgroundColor: '#C6D2ED', minHeight: '100vh' }}>
      {/* <h1 className="text-2xl font-bold mb-4">Directory</h1> */}
      {/* <CasinoDirectoryTable accountId={user.accountId} /> */}
      <CasinoDirectoryTable />
    </div>
  );
};

export default DirectoryPage;